import { ZopAuthLibConfig } from '@zopup/zop-auth';
import { environment } from '../../environment/environment';

export const ADMIN_APP_AUTH_CONFIG: ZopAuthLibConfig = {
  signinRedirectionUrl: '/masters/categories', // Admin app redirects to categories
  routes: {
    signIn: '/auth/sign-in',
    signOut: '/auth/sign-out', 
    tenantSelection: '/admin/tenant-selection',
    tenantCreate: '/admin/tenant-create',
    packageSelection: '/admin/package-selection',
    companyCreate: '/admin/company-create',
    branchSelection: '/admin/branch-selection',
  },
  api: {
    baseUrl: environment.api.baseUrl,
    endpoints: environment.api.endpoints
  },
  keycloak: {
    silentCheckSsoPath: '/silent-check-sso.html'
  },
  features: {
    enableTenantSelection: false, // Admin might not need tenant selection
    enablePackageSelection: true,
    enableCompanyCreation: true,
    enableBranchSelection: false, // Admin might not need branch selection
  },
  fallbackUrls: {
    defaultRedirect: '/masters/categories',
    authFailure: '/auth/sign-in',
    sessionExpired: '/auth/sign-in',
  }
};
